<template>
  <div id="app">
    <router-view></router-view>
    <BackToTop />
  </div>
</template>

<script>
import BackToTop from "./components/BackToTop.vue";

export default {
  name: "App",
  components: { BackToTop },
  mounted() {
    // Default render-event for pages that don't fetch async data
    this.$nextTick(() => {
      setTimeout(() => {
        document.dispatchEvent(new Event("render-event"));
      }, 100);
    });
  },
};
</script>
